<svg width="17" height="19" xmlns="http://www.w3.org/2000/svg">
  <g fill="none" fill-rule="evenodd">
    <ellipse fill="#f3f3f3" cx="8.5" cy="9.031" rx="8.5" ry="9.031" />
    <text
      font-family="HiraginoSans-W6, Hiragino Sans"
      font-size="12"
      font-weight="500"
      fill="#BBB">
      <tspan x="5" y="14">?</tspan>
    </text>
  </g>
</svg>
